module.exports = __webpack_public_path__ + "img/hr-H-B-2-unload-standup-shadow.6de18754.png";